import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const aiLocalizationBannerVars: MotifComponentProps<MotifComponent.AI_LOCALIZATION_BANNER> =
  {
    '--banner-ai-bg-color': m('--neutral-v100'),
    '--banner-ai-fg-color': m('--neutral-v500'),
  } as const;

export const aiLocalizationBannerDarkVars: MotifComponentProps<MotifComponent.AI_LOCALIZATION_BANNER> =
  {
    '--banner-ai-bg-color': m('--neutral-v625'),
    '--banner-ai-fg-color': m('--neutral-v100'),
  } as const;
